import { withStyles } from '@material-ui/core';

import QuickFiltersRow from './component';
import styles from './styles';

export default withStyles(styles)(QuickFiltersRow);
